import { Link } from 'react-router-dom';
import Logo from '../assets/img/logo-128.png';

const Welcome = () => {
  return (
    <div className='Welcome'>
      <img src={Logo} alt="" />
      <h4>Exacthours</h4>
      <p>Exacthours is a simple, powerful time tracking tool for managing work, boosting productivity, and staying organized. Track time and generate reports effortlessly anytime, anywhere.</p>

      <Link to={"/signup"} className="btn btn-site bg-site-light text-site btn-animation fw-medium mt-4">Sign up for free</Link>
      <Link to={"/login"} className="btn btn-site bg-site text-site-light btn-animation fw-medium mt-1">Log in</Link>
    </div>
  )
}

export default Welcome